// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;500;600;700&family=Fira+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   admin-mobifull-web — Custom Styles
   Extends @base-app/web2/styles.css with admin-specific
   layout, components, and the "Orange Dark" professional design.
   ============================================================ */

/* ------------------------------------------------------------
   Design Tokens — admin theme (Refined Orange Identity)
   Supports Light (Default) and Dark (System Preference)
   ------------------------------------------------------------ */

:root {
  /* Fonts */
  --font-heading: "Fira Code", monospace;
  --font-body: "Fira Sans", sans-serif;

  /* Sidebar dimensions */
  --sidebar-width: 240px;

  /* --- Light Theme (Default) --- */
  --color-primary: #ec8e1c;
  --color-primary-hover: #c2410c;
  --color-primary-text: #ffffff;
  --color-primary-soft: rgba(236, 142, 28, 0.1);

  /* Backgrounds */
  --color-bg: #f1f1f1;
  --color-bg-sidebar: #ffffff;
  --color-bg-card: #ffffff;
  --color-bg-input: #ffffff;
  --color-bg-overlay: rgba(0, 0, 0, 0.15);

  /* Text */
  --color-text: #1e1e1e;
  --color-text-muted: #6b7280;
  /* Muted text that still reaches 4.5:1 on the grey page background (muted is 4.28:1 there) */
  --color-text-muted-strong: #4b5563;
  --color-text-sidebar-link: #4b5563;

  /* Borders & dividers */
  --color-border: #ccc;
  --color-border-input: #bbb;
  --color-skeleton: #e6e6e6;
  --color-border-focus: #ec8e1c;

  /* Status */
  --color-success: #059669;
  --color-error: #dc2626;

  /* web2 Variable Overrides (Light) */
  --background: var(--color-bg);
  --text: var(--color-text);
  --nav-bg: var(--color-bg-sidebar);
  --nav-text: var(--color-text);
  --nav-divider: var(--color-border);
  --divider: var(--color-border);
  --link-text: var(--color-primary);
  --link-hover: var(--color-primary-hover);
  --form-border-color: var(--color-border);
  --form-input-border-color: var(--color-border-input);
  --form-input-background-color: var(--color-bg-input);
  --form-input-text-color: var(--color-text);
  --form-button-text-color: #ffffff;
  --form-button-background-color: var(--color-primary);
  --form-button-background-color-hover: var(--color-primary-hover);
  --table-border-color: var(--color-border);
  --table-box-shadow-color: rgba(0, 0, 0, 0.05);
  --table-thead-background-color: #e6e6e6;
  --table-tbody-background-color: #ffffff;
  --table-split-line-color: #ddd;
  --table-th-text-color: var(--color-text);
  --table-tbody-background-color-hover: #f9f9f9;

  @media screen and (prefers-color-scheme: dark) {
    /* --- Dark Theme Overrides --- */
    --color-primary-hover: #d47c10;
    --color-primary-soft: rgba(236, 142, 28, 0.12);

    /* Backgrounds */
    --color-bg: #121212;
    --color-bg-sidebar: #1a1a1a;
    --color-bg-card: #1e1e1e;
    --color-bg-input: #2a2a2a;
    --color-bg-overlay: rgba(0, 0, 0, 0.75);

    /* Text */
    --color-text: #f3f4f6;
    --color-text-muted: #9ca3af;
    --color-text-muted-strong: #9ca3af;
    --color-text-sidebar-link: #d1d5db;

    /* Borders & dividers */
    --color-border: #2e2e2e;
    --color-border-input: #404040;
    --color-skeleton: #2a2a2a;

    /* Status */
    --color-success: #10b981;
    --color-error: #ef4444;

    /* web2 Variable Overrides (Dark) */
    --table-box-shadow-color: rgba(0, 0, 0, 0.4);
    --table-thead-background-color: #242424;
    --table-tbody-background-color: #1a1a1a;
    --table-split-line-color: #2e2e2e;
    --table-tbody-background-color-hover: #2a2a2a;
    --form-button-text-color: #1e1e1e;
  }
}

body {
  font-family: var(--font-body);
  background-color: var(--color-bg);
  color: var(--color-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
h2,
h3,
h4,
h5,
h6,
.code-font {
  font-family: var(--font-heading);
}

/* ============================================================
   Statistics (Dashboard)
   ============================================================ */

.statistics {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-top: 1.5rem;
}

.statistics--item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 1.75rem 2rem;
  min-width: 180px;
  flex: 1;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  cursor: default;
}

.statistics--item:hover {
  transform: translateY(-4px);
  border-color: var(--color-primary);
  box-shadow: 0 10px 15px -3px rgba(236, 142, 28, 0.2);
}

.statistics--item span {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.075em;
  font-family: var(--font-heading);
}

.statistics--item strong {
  font-size: 2.25rem;
  font-weight: 800;
  color: var(--color-primary);
  font-family: var(--font-heading);
  line-height: 1;
}

/* ============================================================
   App Layout — sidebar + content
   ============================================================ */

/* Center the top nav — logout is the only visible item when authenticated.
   The endSlot (language switcher) stays pinned to the right. */
.nav {
  justify-content: center;
  position: relative;
}

.nav > :last-child {
  position: absolute;
  right: 1rem;
}

.app-layout {
  display: grid;
  grid-template-columns: var(--sidebar-width) 1fr;
  height: 100%;
  overflow: hidden;
}

.page-content {
  overflow-y: auto;
  padding: 2.5rem;
  background-color: var(--color-bg);
  color: var(--color-text);
  scrollbar-gutter: stable;
}

/* ============================================================
   Sidebar
   ============================================================ */

.sidebar {
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg-sidebar);
  color: var(--color-text);
  overflow-y: auto;
  border-right: 1px solid var(--color-border);
  padding: 1.5rem 0;
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.3);
}

.sidebar__user {
  display: flex;
  align-items: center;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
  border: none;
  border-bottom: 1px solid var(--color-border);
  gap: 1rem;
  width: 100%;
  text-align: left;
  background: transparent;
  font-family: inherit;
  color: inherit;
  cursor: pointer;
  min-height: 44px;
  transition: background-color 0.2s ease;
}

.sidebar__user:hover {
  background-color: var(--color-primary-soft);
}

.sidebar__user:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: -2px;
}

.sidebar__initials {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background-color: var(--color-primary);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.125rem;
  flex-shrink: 0;
  box-shadow: 0 4px 6px rgba(236, 142, 28, 0.2);
}

.sidebar__user-details {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

.sidebar__name {
  font-size: 0.75rem;
  color: var(--color-text-muted);
  font-family: var(--font-heading);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.sidebar__nav,
.sidebar__scoped-nav {
  display: flex;
  flex-direction: column;
  padding: 0 0.875rem;
  gap: 0.5rem;
}

.sidebar__scoped-nav {
  margin-top: 1.75rem;
  padding-top: 1.75rem;
  border-top: 1px solid var(--color-border);
}

.sidebar__link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  color: var(--color-text-sidebar-link);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.sidebar__link:hover {
  background-color: var(--color-primary-soft);
  color: var(--color-primary);
  padding-left: 1.25rem;
}

.sidebar__link.active {
  background-color: var(--color-primary);
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(236, 142, 28, 0.3);
}

.sidebar__app-select {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.5rem 0.875rem 0;
  margin-top: auto;
  border-top: 1px solid var(--color-border);
}

.sidebar__app-select-fields {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.sidebar__app-actions {
  display: flex;
  gap: 0.5rem;
}

/* ============================================================
   Buttons (Refined Variants)
   ============================================================ */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.625rem 1.25rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  gap: 0.5rem;
  font-family: var(--font-body);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn--primary {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  color: #ffffff;
  box-shadow: 0 4px 6px -1px rgba(236, 142, 28, 0.2);
}

.btn--primary:hover:not(:disabled) {
  background-color: var(--color-primary-hover);
  border-color: var(--color-primary-hover);
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(236, 142, 28, 0.3);
}

.btn--primary:active:not(:disabled) {
  transform: translateY(0);
}

.btn--secondary {
  background-color: var(--color-bg-input);
  border-color: var(--color-border-input);
  color: var(--color-text);
  cursor: pointer;
}

.btn--secondary:hover:not(:disabled) {
  border-color: var(--color-primary);
  color: var(--color-primary);
  background-color: var(--color-primary-soft);
  transform: translateY(-1px);
}

.sidebar__app-actions .btn {
  flex: 1;
  padding: 0.5rem;
  font-size: 0.75rem;
}

.btn--outline {
  background-color: transparent;
  border-color: var(--color-border-input);
  color: var(--color-text);
}

.btn--outline:hover:not(:disabled) {
  border-color: var(--color-primary);
  color: var(--color-primary);
  background-color: var(--color-primary-soft);
}

.btn--ghost {
  background-color: transparent;
  border-color: transparent;
  color: var(--color-text-muted);
}

.btn--ghost:hover:not(:disabled) {
  background-color: var(--color-primary-soft);
  color: var(--color-primary);
}

.btn.btn--loading {
  position: relative;
  color: transparent;
  cursor: wait;
}

.btn__spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.25rem;
  height: 1.25rem;
  margin: -0.625rem 0 0 -0.625rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spinner 0.6s linear infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

/* ============================================================
   Form elements
   ============================================================ */

.form-group {
  margin-bottom: 1.5rem;
}

.form-control {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background-color: var(--color-bg-input);
  color: var(--color-text);
  font-family: inherit;
  font-size: 0.875rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-soft);
}

.form-control::placeholder {
  color: var(--color-text-muted);
  opacity: 0.7;
}

.form-control--error {
  border: 1.5px solid var(--color-error);
}

.form-control--error:focus {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
}

/* Rich text field (RichTextField): a toolbar over a contenteditable, framed like .form-control.
   Tokens only, so light and dark follow the theme. */
.rich-text__box {
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background-color: var(--color-bg-input);
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.rich-text__box:focus-within {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-soft);
}

.rich-text__box--error {
  border: 1.5px solid var(--color-error);
}

.rich-text__toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0.375rem;
  border-bottom: 1px solid var(--color-border-input);
}

.rich-text__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: var(--color-text);
  cursor: pointer;
  transition:
    background-color 0.15s,
    border-color 0.15s;
}

.rich-text__button:hover:not(:disabled) {
  background-color: var(--color-primary-soft);
}

/* Pressed: a border in --color-primary-hover (at least 3:1 on the toolbar in both themes) and an
   inset ring that makes it heavier, so the state is not told by colour alone */
.rich-text__button[aria-pressed="true"],
.rich-text__button[aria-expanded="true"] {
  border-color: var(--color-primary-hover);
  background-color: var(--color-primary-soft);
  box-shadow: inset 0 0 0 1px var(--color-primary-hover);
}

.rich-text__button:focus-visible {
  outline: 2px solid var(--color-primary-hover);
  outline-offset: 1px;
}

/* Touch screens: a 44px target */
@media (pointer: coarse) {
  .rich-text__toolbar {
    gap: 0.5rem;
  }

  .rich-text__button {
    min-width: 2.75rem;
    min-height: 2.75rem;
  }
}

.rich-text__button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.rich-text__link {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.375rem;
  border-bottom: 1px solid var(--color-border-input);
}

.rich-text__link .form-control {
  flex: 1 1 14rem;
  width: auto;
}

.rich-text__link .form-control--error:focus {
  border-color: var(--color-error);
}

.rich-text__link-error {
  flex-basis: 100%;
  margin-top: 0;
}

.rich-text__content {
  min-height: 3.8125rem;
  padding: 0.75rem 1rem;
  color: var(--color-text);
  font-size: 0.875rem;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

/* The box shows the focus ring (:focus-within), so the editable area has none of its own */
.rich-text__content:focus {
  outline: none;
}

.rich-text__content > :first-child {
  margin-top: 0;
}

.rich-text__content > :last-child {
  margin-bottom: 0;
}

.rich-text__content p {
  margin: 0 0 0.5rem;
}

/* The global reset removes the browser's default look of these tags, so the editor restores it */
.rich-text__content strong,
.rich-text__content b {
  font-weight: 700;
}

.rich-text__content em,
.rich-text__content i {
  font-style: italic;
}

.rich-text__content ul,
.rich-text__content ol {
  margin: 0 0 0.5rem;
  padding-left: 1.5rem;
}

.rich-text__content ul {
  list-style: disc;
}

.rich-text__content ol {
  list-style: decimal;
}

.rich-text__content hr {
  margin: 0.75rem 0;
  border: 0;
  border-top: 1px solid var(--color-border-input);
}

.rich-text__content a {
  color: var(--color-primary-hover);
  text-decoration: underline;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--color-border);
}

.checkbox-control {
  appearance: none;
  background-color: var(--color-bg-input);
  margin: 0;
  width: 1.25rem;
  height: 1.25rem;
  border: 1.5px solid var(--color-border-input);
  border-radius: 4px;
  cursor: pointer;
  display: grid;
  place-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-control:hover:not(:disabled) {
  border-color: var(--color-primary);
  background-color: var(--color-primary-soft);
}

.checkbox-control:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-soft);
}

.checkbox-control::before {
  content: "";
  width: 0.65rem;
  height: 0.65rem;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--color-primary);
  transform-origin: bottom left;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
}

.checkbox-control:checked::before {
  transform: scale(1);
}

.checkbox-control:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================================
   Data Table (Cell transitions and headers)
   ============================================================ */

.data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.875rem;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
}

.data-table th {
  text-align: left;
  padding: 1.125rem 1.25rem;
  font-weight: 700;
  font-family: var(--font-heading);
  background-color: var(--table-thead-background-color);
  color: var(--table-th-text-color);
  border-bottom: 1px solid var(--color-border);
  text-transform: uppercase;
  letter-spacing: 0.075em;
  font-size: 0.75rem;
}

.data-table td {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--table-split-line-color);
  color: var(--color-text);
  vertical-align: middle;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.data-table tbody tr:hover td {
  background-color: var(--table-tbody-background-color-hover);
  cursor: pointer;
}

.data-table__loading,
.data-table__empty {
  text-align: center;
  color: var(--color-text-muted);
  padding: 2rem;
}

.table-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

/* Search above a list's table */
.table-toolbar {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.search-input {
  position: relative;
  flex: 1 1 auto;
  max-width: 24rem;
}

.search-input__icon {
  position: absolute;
  left: 0.875rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-text-muted);
  pointer-events: none;
}

.search-input .search-input__field {
  padding-left: 2.5rem;
  padding-right: 2.75rem;
}

/* The X button replaces the browser's own clear control */
.search-input__field::-webkit-search-cancel-button {
  -webkit-appearance: none;
  appearance: none;
}

/* Scoped to outrank the Button atom's .btn rules */
.search-input .search-input__clear {
  position: absolute;
  right: 0.25rem;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--color-text-muted);
  cursor: pointer;
  transition:
    color 0.2s,
    background-color 0.2s;
}

.search-input .search-input__clear:hover {
  color: var(--color-text);
  background-color: var(--color-primary-soft);
}

.search-input .search-input__clear:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 1px;
}

@media (max-width: 640px) {
  .search-input {
    max-width: none;
  }
}

/* Accesses sub-table inside forms */
.accesses-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
  margin-top: 0.5rem;
}

.accesses-table th,
.accesses-table td {
  padding: 0.4rem 0.6rem;
  border: 1px solid var(--color-border);
  text-align: left;
}

.accesses-table thead {
  background-color: var(--table-thead-background-color);
}

/* ============================================================
   Pagination
   ============================================================ */

.pagination {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  flex-wrap: wrap;
  font-size: 0.875rem;
}

.pagination select {
  background-color: var(--color-bg-input);
  color: var(--color-text);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  padding: 0.3rem 0.5rem;
  cursor: pointer;
}

.pagination button {
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background-color: var(--color-bg-input);
  color: var(--color-text);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.pagination button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pagination button:not(:disabled):hover {
  background-color: var(--table-tbody-background-color-hover);
}

.pagination__page--active {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  color: #ffffff;
}

/* ============================================================
   Modal
   ============================================================ */

.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: var(--color-bg-overlay);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1.5rem;
  animation: fadeIn 0.3s ease-out;
}

.modal {
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  width: 100%;
  max-width: 540px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(20px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--color-border);
}

.modal__header h2 {
  font-size: 1.1rem;
  font-weight: 600;
}

.modal__close {
  padding: 0.25rem;
  font-size: 1.5rem;
  color: var(--color-text-muted);
  line-height: 1;
  transition: color 0.15s;
}

.modal__close:hover {
  color: var(--color-text);
}

.modal__body {
  padding: 1.5rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.modal__footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  width: 100%;
}

.modal__confirm-message {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--color-text);
  margin: 0;
}

/* ============================================================
   Label and ErrorMessage
   ============================================================ */

label,
.form-label {
  display: block;
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.075em;
  margin-bottom: 0.5rem;
  transition: color 0.2s;
}

label:has(+ .form-control:focus),
label:has(+ .checkbox-control:focus) {
  color: var(--color-primary);
}

.checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-family: var(--font-body);
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text);
  text-transform: none;
  letter-spacing: normal;
  cursor: pointer;
  margin-bottom: 0;
  user-select: none;
}

.checkbox-label .checkbox-control {
  flex-shrink: 0;
}

.form-load-state {
  min-height: 6rem;
  padding: 1.5rem 0;
  color: var(--color-text-muted);
  line-height: 1.5;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.skeleton {
  display: block;
  width: 100%;
  border-radius: 8px;
  background-color: var(--color-skeleton);
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}

/* Each shape matches the rendered size of the component it stands in for */
.skeleton--input {
  height: 2.625rem;
}

.skeleton--textarea {
  height: 3.8125rem;
}

.skeleton--upload {
  height: 3.3125rem;
}

/* The radio stream player */
.skeleton--audio {
  height: 4.625rem;
  border-radius: 12px;
}

/* A line of hint text, such as the upload field's accepted types */
.skeleton--text {
  width: 60%;
  height: 0.75rem;
  margin: 0.625rem 0 0.75rem;
  border-radius: 4px;
}

.skeleton--checkbox {
  display: inline-block;
  vertical-align: middle;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 4px;
  flex-shrink: 0;
}

.skeleton--button {
  display: inline-block;
  vertical-align: top;
  width: 4.5rem;
  height: 2.4375rem;
}

@keyframes skeleton-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }
}

.form-hint {
  display: block;
  font-size: 0.75rem;
  color: var(--color-text-muted);
  margin-top: 0.375rem;
  margin-bottom: 0.5rem;
  font-style: italic;
  line-height: 1.4;
}

.error-text {
  color: var(--color-error);
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  animation: fadeIn 0.2s ease-out;
}

.error-text::before {
  content: "⚠";
  font-size: 0.875rem;
}

/* ============================================================
   Data Table (Cell transitions and headers)
   ============================================================ */

.data-table__spinner-container,
.data-table__empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 1rem;
  color: var(--color-text-muted);
}

.data-table__spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid rgba(236, 142, 28, 0.2);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spinner 0.8s linear infinite;
}

/* A long search term in "No results for …" wraps instead of widening the table */
.data-table__empty-container span {
  max-width: 100%;
  overflow-wrap: anywhere;
}

.data-table__empty-icon {
  opacity: 0.6;
}

/* ============================================================
   Pagination (Refined)
   ============================================================ */

.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0.5rem;
  margin-top: 1rem;
  gap: 1.5rem;
}

.pagination__size-selector select {
  background-color: var(--color-bg-input);
  color: var(--color-text);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
}

.pagination__size-selector select:focus {
  outline: none;
  border-color: var(--color-border-focus);
}

.pagination__controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pagination__pages {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.pagination__pages .btn {
  padding: 0.5rem 0.875rem;
  min-width: 2.5rem;
}

/* ============================================================
   Status / feedback text
   ============================================================ */

.success-text {
  color: var(--color-success);
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.375rem;
}

/* ============================================================
   Login page — full-screen centered card
   ============================================================ */

.main:has(.container:has(.auth-card)) {
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-card {
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 3rem 2.5rem;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.4);
}

.auth-card__title {
  font-size: 1.75rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 2.5rem;
  color: var(--color-text);
}

.auth-card__content {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.auth-card__footer {
  margin-top: 1.5rem;
  text-align: center;
}

/* ============================================================
   Layout & Page Structure
   ============================================================ */

.container {
  width: 100%;
}

.container--center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.page-header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.page-header__content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.page-header__title {
  margin: 0;
  font-size: 1.875rem;
  font-weight: 700;
  color: var(--color-text);
}

.page-header__subtitle {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.875rem;
}

.page-header__actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}

/* Select Atom Styles - UI/UX Pro Max Improvements */
.select-atom-container {
  position: relative;
  display: block;
  width: 100%;
}

.select-atom {
  appearance: none;
  background-image: none;
  padding-right: 2.5rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1.5px solid var(--color-border-input);
  background-color: var(--color-bg-input);
  color: var(--color-text);
}

.select-atom:hover:not(:disabled) {
  border-color: var(--color-text-muted);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.select-atom:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-soft);
}

.select-atom--disabled {
  background-color: var(--color-bg);
  cursor: not-allowed;
  color: var(--color-text-muted);
  opacity: 0.7;
}

.select-atom__icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--color-text-muted);
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease-in-out;
}

.select-atom:focus + .select-atom__icon {
  color: var(--color-primary);
}

.form-control--error.select-atom {
  border-color: var(--color-error);
}

.form-control--error.select-atom:focus {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

/* ============================================================
   Permission Matrix (Refined Design)
   ============================================================ */

.permission-matrix {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  /* No overflow:hidden: it clips the caption (the grid's title) at the rounded corner; the corner
     cells below are rounded instead */
  font-size: 0.875rem;
  margin-top: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.permission-matrix th {
  background-color: var(--table-thead-background-color);
  color: var(--color-text-muted);
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.075em;
  padding: 0.875rem 1rem;
  text-align: center;
  border-bottom: 1px solid var(--color-border);
}

.permission-matrix th:first-child {
  text-align: left;
}

.permission-matrix thead th:first-child {
  border-top-left-radius: 9px;
}

.permission-matrix thead th:last-child {
  border-top-right-radius: 9px;
}

.permission-matrix tbody tr:last-child > :first-child {
  border-bottom-left-radius: 9px;
}

.permission-matrix tbody tr:last-child > :last-child {
  border-bottom-right-radius: 9px;
}

/* The row header looks like the first cell it replaces, not like a column header */
.permission-matrix tbody th[scope="row"] {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--color-border);
  background: transparent;
  text-transform: none;
  font-size: inherit;
  vertical-align: middle;
}

/* The grid's title, where the old <label> above the table was. Not .form-label: its display:block
   would turn the caption into an ordinary box that renders below the header row */
.permission-matrix__caption {
  display: table-caption;
  caption-side: top;
  text-align: left;
  padding: 0 0 0.5rem;
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.075em;
}

.permission-matrix td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
}

.permission-matrix td:first-child,
.permission-matrix tbody th[scope="row"] {
  text-align: left;
  font-family: var(--font-heading);
  font-weight: 600;
  color: var(--color-text);
}

.permission-matrix tbody tr:last-child td,
.permission-matrix tbody tr:last-child th[scope="row"] {
  border-bottom: none;
}

.permission-matrix:hover {
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-color: var(--color-primary-soft);
}

.permission-matrix tbody tr:hover td,
.permission-matrix tbody tr:hover th[scope="row"] {
  background-color: var(--table-tbody-background-color-hover);
}

.permission-matrix--disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
  filter: grayscale(0.5);
}

.permission-matrix td .checkbox-control {
  margin: 0 auto;
}

.modal--wide {
  max-width: 680px;
}

/* ============================================================
   Audio Atom
   ============================================================ */

.audio-atom {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  margin-bottom: 1rem;
}

.audio-atom__label {
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.075em;
}

.audio-atom__wrapper {
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 0.75rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.audio-atom__wrapper:hover {
  border-color: var(--color-primary);
  box-shadow: 0 10px 15px -3px var(--color-primary-soft);
}

.audio-atom--error .audio-atom__wrapper {
  border-color: var(--color-error);
}

.audio-atom__native {
  display: none;
}

.audio-atom__controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.audio-atom__btn {
  background-color: var(--color-primary-soft);
  color: var(--color-primary);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.audio-atom__btn:hover:not(:disabled) {
  background-color: var(--color-primary);
  color: var(--color-primary-text);
  transform: scale(1.05);
}

.audio-atom__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  filter: grayscale(1);
}

.audio-atom__icon {
  width: 20px;
  height: 20px;
}

.audio-atom__info {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.audio-atom__status {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.audio-atom--error .audio-atom__status {
  color: var(--color-error);
}

.audio-atom__source {
  font-size: 0.75rem;
  color: var(--color-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--font-heading);
}

.audio-atom__error-msg {
  font-size: 0.75rem;
  color: var(--color-error);
  font-weight: 500;
}

.audio-atom__btn:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

@media (prefers-color-scheme: dark) {
  .audio-atom__wrapper {
    background-color: var(--color-bg-input);
  }
}

.audio-atom__volume {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 100px;
  margin-left: 0.5rem;
}

.audio-atom__slider {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: var(--color-border);
  outline: none;
  cursor: pointer;
}

.audio-atom__slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--color-primary);
  cursor: pointer;
  transition: transform 0.1s ease;
}

.audio-atom__slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
}

.audio-atom__slider:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.audio-atom {
  container-type: inline-size;
}

.audio-atom__controls {
  flex-wrap: wrap;
}

.audio-atom__stop-btn {
  background-color: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}

.audio-atom__stop-btn:hover:not(:disabled) {
  background-color: #dc2626;
  color: #ffffff;
}

/* When the atom's own width is tight, drop the volume row below play/stop/info.
   Natural DOM order is preserved: [play][stop][info flex:1] / [volume full-width] */
@container (max-width: 460px) {
  .audio-atom__controls {
    gap: 0.75rem;
  }

  .audio-atom__volume {
    width: 100%;
    margin-left: 0;
  }
}

/* ============================================================
   Settings — My Profile (/settings/me)
   ============================================================ */

.settings-me {
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  overflow: hidden;
  max-width: 560px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  margin: 0;
  padding: 0;
}

.settings-me__field,
.settings-me__roles {
  display: flex;
  align-items: flex-start;
  padding: 1.125rem 1.5rem;
  border-bottom: 1px solid var(--color-border);
  gap: 1rem;
}

.settings-me__field:last-child,
.settings-me__roles:last-child {
  border-bottom: none;
}

.settings-me__label {
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.075em;
  min-width: 80px;
  padding-top: 0.125rem;
  margin: 0;
}

.settings-me__value {
  font-size: 0.9375rem;
  color: var(--color-text);
  font-weight: 500;
  margin: 0;
}

.settings-me__role-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.settings-me__role-tag {
  background-color: var(--color-primary-soft);
  color: var(--color-primary);
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.625rem;
  border-radius: 6px;
  border: 1px solid rgba(236, 142, 28, 0.2);
}

.settings-me__empty {
  font-size: 0.875rem;
  color: var(--color-text-muted);
  font-style: italic;
}

/* ============================================================
   Images — list thumbnails and the upload field
   ============================================================ */

.thumbnail {
  display: inline-block;
  vertical-align: middle;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid var(--color-border);
  background-color: var(--color-bg);
}

.thumbnail--round {
  border-radius: 50%;
}

/* Low-res copy first, full image faded in over it once loaded (ProgressiveImage atom).
   The copy is hidden only after the fade, so nothing blinks and transparent images
   don't keep a blurry copy behind them. */
.progressive-image {
  position: relative;
  overflow: hidden;
}

.progressive-image > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.progressive-image__full {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.2s ease-out;
}

.progressive-image[data-loaded="true"] .progressive-image__full {
  opacity: 1;
}

.progressive-image[data-loaded="true"] .progressive-image__low-res {
  visibility: hidden;
  transition: visibility 0s linear 0.2s;
}

@media (prefers-reduced-motion: reduce) {
  .progressive-image__full,
  .progressive-image[data-loaded="true"] .progressive-image__low-res {
    transition: none;
  }
}

.thumbnail--empty {
  border: 0;
  background: none;
  color: var(--color-text-muted);
}

.image-upload__preview {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.image-upload__image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  background-color: var(--color-bg);
}

.image-upload__input {
  display: block;
  width: 100%;
  padding: 0.5rem;
  border: 1px dashed var(--color-border-input);
  border-radius: 8px;
  background-color: var(--color-bg-input);
  color: var(--color-text-muted);
  font-family: inherit;
  font-size: 0.875rem;
  cursor: pointer;
  box-sizing: border-box;
  transition:
    border-color 0.2s,
    background-color 0.2s;
}

.image-upload__input:hover:not(:disabled) {
  border-color: var(--color-primary);
  background-color: var(--color-primary-soft);
}

.image-upload__input:focus-visible {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-soft);
}

.image-upload__input:disabled {
  opacity: 0.6;
  cursor: progress;
}

.image-upload__input::file-selector-button {
  margin-right: 0.75rem;
  padding: 0.5rem 1rem;
  border: 1px solid var(--color-primary);
  border-radius: 6px;
  background-color: var(--color-bg-card);
  color: var(--color-primary);
  font-family: var(--font-body);
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color 0.2s,
    color 0.2s;
}

.image-upload__input:hover:not(:disabled)::file-selector-button {
  background-color: var(--color-primary);
  color: var(--color-primary-text);
}

/* Checkbox group (fieldset + legend styled like a field label) */
.checkbox-group {
  border: 0;
  padding: 0;
  margin: 0 0 1.5rem;
  min-width: 0;
}

/* A titled group of inputs inside a form (the "Mobile app" fieldset of the application form): the
   browser's border, padding and serif legend reset to the form's look */
.form-fieldset {
  min-width: 0;
  border: 0;
  padding: 0;
  margin-inline: 0;
}

.form-fieldset legend {
  padding: 0;
  font-family: var(--font-heading);
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.75rem;
}

.checkbox-group legend {
  width: 100%;
  padding: 0;
  text-align: center;
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.075em;
  margin-bottom: 0.5rem;
}

.checkbox-group__options {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem 1.5rem;
}

.checkbox-group .checkbox-label {
  min-height: 44px;
}

@media (prefers-reduced-motion: reduce) {
  .image-upload__input,
  .image-upload__input::file-selector-button {
    transition: none;
  }
}

/* ============================================================
   Alignment: the base shell centers text; forms and table cells
   read left-aligned so labels, hints and errors line up with
   their inputs and cells line up with their headers
   ============================================================ */

.form-group,
.data-table td {
  text-align: left;
}

.page-hint {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  margin-top: 0.5rem;
}

/* SecretField: masked input with a Show/Hide button on its right */
.secret-field {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}

.secret-field .form-control {
  flex: 1;
  min-width: 0;
}

.secret-field__toggle {
  flex-shrink: 0;
  min-width: 5.5rem;
  min-height: 44px;
}

/* PageSkeleton: the Suspense fallback while a page's code loads */
.page-skeleton {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
}

.skeleton--heading {
  width: 14rem;
  max-width: 60%;
  height: 2.25rem;
}

.page-skeleton__button {
  width: 8rem;
}

.skeleton--table {
  height: 15rem;
  border-radius: 10px;
  margin-top: 1rem;
}

.data-table__error-icon {
  color: var(--color-error);
}

/* "Locked" marker on the collaborator functions list: darker text than the shared tag, 4.5:1 in both themes */
.collaborator-functions__locked {
  background-color: var(--color-primary-soft);
  color: #9a3412;
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.625rem;
  border-radius: 6px;
  border: 1px solid rgba(236, 142, 28, 0.2);
}

@media (prefers-color-scheme: dark) {
  .collaborator-functions__locked {
    color: var(--color-primary);
  }
}

/* Why a function can't be deleted, next to its disabled Delete: the shared .form-hint colour is
   4.28:1 on the light page background, so this uses a darker grey (4.5:1+ in both themes) */
.collaborator-functions__in-use {
  font-size: 0.75rem;
  font-style: italic;
  line-height: 1.4;
  color: var(--color-text-muted-strong);
}

/* Collaborators list: the function names failed to load */
.collaborators__unavailable {
  font-style: italic;
  color: var(--color-text-muted-strong);
}

.collaborators__functions-error {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

/* Feed retention notice icon and title in modal header */
.feed-modal-title {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.feed-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 50%;
  cursor: help;
  color: var(--color-text-muted-strong);
  border: 1px solid currentColor;
  user-select: none;
  vertical-align: middle;
  line-height: 1;
}

.feed-info-icon:hover,
.feed-info-icon:focus-visible {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

/* Tabs molecule (application page): a row of buttons over panels that stay mounted */
.tabs__list {
  display: flex;
  gap: 0.25rem;
  overflow-x: auto;
  border-bottom: 1px solid var(--color-border);
  margin-bottom: 1.5rem;
}

.tabs__tab {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  flex: none;
  padding: 0.625rem 1rem;
  min-height: 2.75rem;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  color: var(--color-text-muted-strong);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.tabs__tab:hover {
  color: var(--color-text);
}

.tabs__tab:focus-visible {
  outline: 2px solid var(--color-border-focus);
  outline-offset: -2px;
}

.tabs__tab--active {
  color: var(--color-text);
  border-bottom-color: var(--color-primary);
}

/* The label keeps the text colour (the error red on the page background is 4.28:1 in the light
   theme); the red underline and the marker carry the error */
.tabs__tab--error {
  border-bottom-color: var(--color-error);
}

.tabs__marker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 50%;
  background: var(--color-error);
  color: var(--color-primary-text);
  font-size: 0.75rem;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAIjE;;;iEAGiE;;AAEjE;EACE,UAAU;EACV,sCAAsC;EACtC,oCAAoC;;EAEpC,uBAAuB;EACvB,sBAAsB;;EAEtB,kCAAkC;EAClC,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,6CAA6C;;EAE7C,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,uCAAuC;;EAEvC,SAAS;EACT,qBAAqB;EACrB,2BAA2B;EAC3B,4FAA4F;EAC5F,kCAAkC;EAClC,kCAAkC;;EAElC,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;;EAE7B,WAAW;EACX,wBAAwB;EACxB,sBAAsB;;EAEtB,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,kCAAkC;EAClC,8BAA8B;EAC9B,iCAAiC;EACjC,wCAAwC;EACxC,wCAAwC;EACxC,oDAAoD;EACpD,oDAAoD;EACpD,0CAA0C;EAC1C,iCAAiC;EACjC,oDAAoD;EACpD,gEAAgE;EAChE,yCAAyC;EACzC,6CAA6C;EAC7C,uCAAuC;EACvC,uCAAuC;EACvC,8BAA8B;EAC9B,wCAAwC;EACxC,6CAA6C;;EAE7C;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,8CAA8C;;IAE9C,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,uCAAuC;;IAEvC,SAAS;IACT,qBAAqB;IACrB,2BAA2B;IAC3B,kCAAkC;IAClC,kCAAkC;;IAElC,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;;IAEzB,WAAW;IACX,wBAAwB;IACxB,sBAAsB;;IAEtB,mCAAmC;IACnC,4CAA4C;IAC5C,uCAAuC;IACvC,uCAAuC;IACvC,iCAAiC;IACjC,6CAA6C;IAC7C,iCAAiC;EACnC;AACF;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;;;;EAOE,gCAAgC;AAClC;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,OAAO;EACP,iDAAiD;EACjD,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;+DAC+D;AAC/D;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,wBAAwB;EACxB,gBAAgB;EAChB,2CAA2C;EAC3C,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,4CAA4C;EAC5C,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;iEAEiE;;AAEjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,iDAAiD;EACjD,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;iEAEiE;;AAEjE;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2CAA2C;EAC3C,kBAAkB;EAClB,uCAAuC;EACvC,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;qDACqD;AACrD;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,uCAAuC;EACvC;;mBAEiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf;;sBAEoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;+EAC+E;AAC/E;;EAEE,wCAAwC;EACxC,2CAA2C;EAC3C,sDAAsD;AACxD;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,2FAA2F;AAC3F;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iGAAiG;AACjG;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,SAAS;EACT,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,8CAA8C;EAC9C,6BAA6B;EAC7B,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,qDAAqD;EACrD,iCAAiC;EACjC,4CAA4C;EAC5C,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sDAAsD;EACtD,wBAAwB;EACxB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,2CAA2C;EAC3C,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,uCAAuC;EACvC,wBAAwB;EACxB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE,eAAe;EACf,QAAQ;EACR,yCAAyC;EACzC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;;iEAEiE;;AAEjE;;EAEE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,mDAAmD;AACrD;;AAEA,2EAA2E;AAC3E;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,sCAAsC;EACtC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,iFAAiF;AACjF;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;iEAEiE;;AAEjE;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,iDAAiD;EACjD,6CAA6C;EAC7C,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;iEAEiE;;AAEjE;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB;sCACoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;EACE,qDAAqD;EACrD,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mFAAmF;AACnF;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;kFACkF;AAClF;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,sBAAsB;EACtB,8DAA8D;EAC9D,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;;sCAEoC;EACpC,uCAAuC;AACzC;;AAEA;;EAEE,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;oFACoF;AACpF;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,4CAA4C;EAC5C,SAAS;AACX;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;0CAE0C;AAC1C;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB;;yBAEuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,sCAAsC;EACtC,kBAAkB;EAClB,sCAAsC;EACtC,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf;;cAEY;AACd;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA,iEAAiE;AACjE;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;wEACwE;AACxE;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;;;iEAIiE;;AAEjE;;EAEE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8GAA8G;AAC9G;EACE,2CAA2C;EAC3C,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;4FAC4F;AAC5F;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,qFAAqF;AACrF;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;6DAC6D;AAC7D;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* ============================================================\n   admin-mobifull-web — Custom Styles\n   Extends @base-app/web2/styles.css with admin-specific\n   layout, components, and the \"Orange Dark\" professional design.\n   ============================================================ */\n\n@import url(\"https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;500;600;700&family=Fira+Sans:wght@300;400;500;600;700&display=swap\");\n\n/* ------------------------------------------------------------\n   Design Tokens — admin theme (Refined Orange Identity)\n   Supports Light (Default) and Dark (System Preference)\n   ------------------------------------------------------------ */\n\n:root {\n  /* Fonts */\n  --font-heading: \"Fira Code\", monospace;\n  --font-body: \"Fira Sans\", sans-serif;\n\n  /* Sidebar dimensions */\n  --sidebar-width: 240px;\n\n  /* --- Light Theme (Default) --- */\n  --color-primary: #ec8e1c;\n  --color-primary-hover: #c2410c;\n  --color-primary-text: #ffffff;\n  --color-primary-soft: rgba(236, 142, 28, 0.1);\n\n  /* Backgrounds */\n  --color-bg: #f1f1f1;\n  --color-bg-sidebar: #ffffff;\n  --color-bg-card: #ffffff;\n  --color-bg-input: #ffffff;\n  --color-bg-overlay: rgba(0, 0, 0, 0.15);\n\n  /* Text */\n  --color-text: #1e1e1e;\n  --color-text-muted: #6b7280;\n  /* Muted text that still reaches 4.5:1 on the grey page background (muted is 4.28:1 there) */\n  --color-text-muted-strong: #4b5563;\n  --color-text-sidebar-link: #4b5563;\n\n  /* Borders & dividers */\n  --color-border: #ccc;\n  --color-border-input: #bbb;\n  --color-skeleton: #e6e6e6;\n  --color-border-focus: #ec8e1c;\n\n  /* Status */\n  --color-success: #059669;\n  --color-error: #dc2626;\n\n  /* web2 Variable Overrides (Light) */\n  --background: var(--color-bg);\n  --text: var(--color-text);\n  --nav-bg: var(--color-bg-sidebar);\n  --nav-text: var(--color-text);\n  --nav-divider: var(--color-border);\n  --divider: var(--color-border);\n  --link-text: var(--color-primary);\n  --link-hover: var(--color-primary-hover);\n  --form-border-color: var(--color-border);\n  --form-input-border-color: var(--color-border-input);\n  --form-input-background-color: var(--color-bg-input);\n  --form-input-text-color: var(--color-text);\n  --form-button-text-color: #ffffff;\n  --form-button-background-color: var(--color-primary);\n  --form-button-background-color-hover: var(--color-primary-hover);\n  --table-border-color: var(--color-border);\n  --table-box-shadow-color: rgba(0, 0, 0, 0.05);\n  --table-thead-background-color: #e6e6e6;\n  --table-tbody-background-color: #ffffff;\n  --table-split-line-color: #ddd;\n  --table-th-text-color: var(--color-text);\n  --table-tbody-background-color-hover: #f9f9f9;\n\n  @media screen and (prefers-color-scheme: dark) {\n    /* --- Dark Theme Overrides --- */\n    --color-primary-hover: #d47c10;\n    --color-primary-soft: rgba(236, 142, 28, 0.12);\n\n    /* Backgrounds */\n    --color-bg: #121212;\n    --color-bg-sidebar: #1a1a1a;\n    --color-bg-card: #1e1e1e;\n    --color-bg-input: #2a2a2a;\n    --color-bg-overlay: rgba(0, 0, 0, 0.75);\n\n    /* Text */\n    --color-text: #f3f4f6;\n    --color-text-muted: #9ca3af;\n    --color-text-muted-strong: #9ca3af;\n    --color-text-sidebar-link: #d1d5db;\n\n    /* Borders & dividers */\n    --color-border: #2e2e2e;\n    --color-border-input: #404040;\n    --color-skeleton: #2a2a2a;\n\n    /* Status */\n    --color-success: #10b981;\n    --color-error: #ef4444;\n\n    /* web2 Variable Overrides (Dark) */\n    --table-box-shadow-color: rgba(0, 0, 0, 0.4);\n    --table-thead-background-color: #242424;\n    --table-tbody-background-color: #1a1a1a;\n    --table-split-line-color: #2e2e2e;\n    --table-tbody-background-color-hover: #2a2a2a;\n    --form-button-text-color: #1e1e1e;\n  }\n}\n\nbody {\n  font-family: var(--font-body);\n  background-color: var(--color-bg);\n  color: var(--color-text);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.code-font {\n  font-family: var(--font-heading);\n}\n\n/* ============================================================\n   Statistics (Dashboard)\n   ============================================================ */\n\n.statistics {\n  display: flex;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n  margin-top: 1.5rem;\n}\n\n.statistics--item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.75rem;\n  background-color: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 1.75rem 2rem;\n  min-width: 180px;\n  flex: 1;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  cursor: default;\n}\n\n.statistics--item:hover {\n  transform: translateY(-4px);\n  border-color: var(--color-primary);\n  box-shadow: 0 10px 15px -3px rgba(236, 142, 28, 0.2);\n}\n\n.statistics--item span {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.075em;\n  font-family: var(--font-heading);\n}\n\n.statistics--item strong {\n  font-size: 2.25rem;\n  font-weight: 800;\n  color: var(--color-primary);\n  font-family: var(--font-heading);\n  line-height: 1;\n}\n\n/* ============================================================\n   App Layout — sidebar + content\n   ============================================================ */\n\n/* Center the top nav — logout is the only visible item when authenticated.\n   The endSlot (language switcher) stays pinned to the right. */\n.nav {\n  justify-content: center;\n  position: relative;\n}\n\n.nav > :last-child {\n  position: absolute;\n  right: 1rem;\n}\n\n.app-layout {\n  display: grid;\n  grid-template-columns: var(--sidebar-width) 1fr;\n  height: 100%;\n  overflow: hidden;\n}\n\n.page-content {\n  overflow-y: auto;\n  padding: 2.5rem;\n  background-color: var(--color-bg);\n  color: var(--color-text);\n  scrollbar-gutter: stable;\n}\n\n/* ============================================================\n   Sidebar\n   ============================================================ */\n\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--color-bg-sidebar);\n  color: var(--color-text);\n  overflow-y: auto;\n  border-right: 1px solid var(--color-border);\n  padding: 1.5rem 0;\n  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.3);\n}\n\n.sidebar__user {\n  display: flex;\n  align-items: center;\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1.5rem;\n  border: none;\n  border-bottom: 1px solid var(--color-border);\n  gap: 1rem;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  font-family: inherit;\n  color: inherit;\n  cursor: pointer;\n  min-height: 44px;\n  transition: background-color 0.2s ease;\n}\n\n.sidebar__user:hover {\n  background-color: var(--color-primary-soft);\n}\n\n.sidebar__user:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: -2px;\n}\n\n.sidebar__initials {\n  width: 42px;\n  height: 42px;\n  border-radius: 10px;\n  background-color: var(--color-primary);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 1.125rem;\n  flex-shrink: 0;\n  box-shadow: 0 4px 6px rgba(236, 142, 28, 0.2);\n}\n\n.sidebar__user-details {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.sidebar__name {\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n  font-family: var(--font-heading);\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.sidebar__nav,\n.sidebar__scoped-nav {\n  display: flex;\n  flex-direction: column;\n  padding: 0 0.875rem;\n  gap: 0.5rem;\n}\n\n.sidebar__scoped-nav {\n  margin-top: 1.75rem;\n  padding-top: 1.75rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.sidebar__link {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  color: var(--color-text-sidebar-link);\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n}\n\n.sidebar__link:hover {\n  background-color: var(--color-primary-soft);\n  color: var(--color-primary);\n  padding-left: 1.25rem;\n}\n\n.sidebar__link.active {\n  background-color: var(--color-primary);\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(236, 142, 28, 0.3);\n}\n\n.sidebar__app-select {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  padding: 1.5rem 0.875rem 0;\n  margin-top: auto;\n  border-top: 1px solid var(--color-border);\n}\n\n.sidebar__app-select-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n}\n\n.sidebar__app-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* ============================================================\n   Buttons (Refined Variants)\n   ============================================================ */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.625rem 1.25rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n  gap: 0.5rem;\n  font-family: var(--font-body);\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn--primary {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n  color: #ffffff;\n  box-shadow: 0 4px 6px -1px rgba(236, 142, 28, 0.2);\n}\n\n.btn--primary:hover:not(:disabled) {\n  background-color: var(--color-primary-hover);\n  border-color: var(--color-primary-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 15px -3px rgba(236, 142, 28, 0.3);\n}\n\n.btn--primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn--secondary {\n  background-color: var(--color-bg-input);\n  border-color: var(--color-border-input);\n  color: var(--color-text);\n  cursor: pointer;\n}\n\n.btn--secondary:hover:not(:disabled) {\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n  background-color: var(--color-primary-soft);\n  transform: translateY(-1px);\n}\n\n.sidebar__app-actions .btn {\n  flex: 1;\n  padding: 0.5rem;\n  font-size: 0.75rem;\n}\n\n.btn--outline {\n  background-color: transparent;\n  border-color: var(--color-border-input);\n  color: var(--color-text);\n}\n\n.btn--outline:hover:not(:disabled) {\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n  background-color: var(--color-primary-soft);\n}\n\n.btn--ghost {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--color-text-muted);\n}\n\n.btn--ghost:hover:not(:disabled) {\n  background-color: var(--color-primary-soft);\n  color: var(--color-primary);\n}\n\n.btn.btn--loading {\n  position: relative;\n  color: transparent;\n  cursor: wait;\n}\n\n.btn__spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 1.25rem;\n  height: 1.25rem;\n  margin: -0.625rem 0 0 -0.625rem;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: spinner 0.6s linear infinite;\n}\n\n@keyframes spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ============================================================\n   Form elements\n   ============================================================ */\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-control {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background-color: var(--color-bg-input);\n  color: var(--color-text);\n  font-family: inherit;\n  font-size: 0.875rem;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-sizing: border-box;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-soft);\n}\n\n.form-control::placeholder {\n  color: var(--color-text-muted);\n  opacity: 0.7;\n}\n\n.form-control--error {\n  border: 1.5px solid var(--color-error);\n}\n\n.form-control--error:focus {\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);\n}\n\n/* Rich text field (RichTextField): a toolbar over a contenteditable, framed like .form-control.\n   Tokens only, so light and dark follow the theme. */\n.rich-text__box {\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background-color: var(--color-bg-input);\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.rich-text__box:focus-within {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-soft);\n}\n\n.rich-text__box--error {\n  border: 1.5px solid var(--color-error);\n}\n\n.rich-text__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  padding: 0.375rem;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.rich-text__button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--color-text);\n  cursor: pointer;\n  transition:\n    background-color 0.15s,\n    border-color 0.15s;\n}\n\n.rich-text__button:hover:not(:disabled) {\n  background-color: var(--color-primary-soft);\n}\n\n/* Pressed: a border in --color-primary-hover (at least 3:1 on the toolbar in both themes) and an\n   inset ring that makes it heavier, so the state is not told by colour alone */\n.rich-text__button[aria-pressed=\"true\"],\n.rich-text__button[aria-expanded=\"true\"] {\n  border-color: var(--color-primary-hover);\n  background-color: var(--color-primary-soft);\n  box-shadow: inset 0 0 0 1px var(--color-primary-hover);\n}\n\n.rich-text__button:focus-visible {\n  outline: 2px solid var(--color-primary-hover);\n  outline-offset: 1px;\n}\n\n/* Touch screens: a 44px target */\n@media (pointer: coarse) {\n  .rich-text__toolbar {\n    gap: 0.5rem;\n  }\n\n  .rich-text__button {\n    min-width: 2.75rem;\n    min-height: 2.75rem;\n  }\n}\n\n.rich-text__button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.rich-text__link {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.375rem;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.rich-text__link .form-control {\n  flex: 1 1 14rem;\n  width: auto;\n}\n\n.rich-text__link .form-control--error:focus {\n  border-color: var(--color-error);\n}\n\n.rich-text__link-error {\n  flex-basis: 100%;\n  margin-top: 0;\n}\n\n.rich-text__content {\n  min-height: 3.8125rem;\n  padding: 0.75rem 1rem;\n  color: var(--color-text);\n  font-size: 0.875rem;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n\n/* The box shows the focus ring (:focus-within), so the editable area has none of its own */\n.rich-text__content:focus {\n  outline: none;\n}\n\n.rich-text__content > :first-child {\n  margin-top: 0;\n}\n\n.rich-text__content > :last-child {\n  margin-bottom: 0;\n}\n\n.rich-text__content p {\n  margin: 0 0 0.5rem;\n}\n\n/* The global reset removes the browser's default look of these tags, so the editor restores it */\n.rich-text__content strong,\n.rich-text__content b {\n  font-weight: 700;\n}\n\n.rich-text__content em,\n.rich-text__content i {\n  font-style: italic;\n}\n\n.rich-text__content ul,\n.rich-text__content ol {\n  margin: 0 0 0.5rem;\n  padding-left: 1.5rem;\n}\n\n.rich-text__content ul {\n  list-style: disc;\n}\n\n.rich-text__content ol {\n  list-style: decimal;\n}\n\n.rich-text__content hr {\n  margin: 0.75rem 0;\n  border: 0;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.rich-text__content a {\n  color: var(--color-primary-hover);\n  text-decoration: underline;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.checkbox-control {\n  appearance: none;\n  background-color: var(--color-bg-input);\n  margin: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  border: 1.5px solid var(--color-border-input);\n  border-radius: 4px;\n  cursor: pointer;\n  display: grid;\n  place-content: center;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.checkbox-control:hover:not(:disabled) {\n  border-color: var(--color-primary);\n  background-color: var(--color-primary-soft);\n}\n\n.checkbox-control:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-soft);\n}\n\n.checkbox-control::before {\n  content: \"\";\n  width: 0.65rem;\n  height: 0.65rem;\n  transform: scale(0);\n  transition: 120ms transform ease-in-out;\n  box-shadow: inset 1em 1em var(--color-primary);\n  transform-origin: bottom left;\n  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);\n}\n\n.checkbox-control:checked::before {\n  transform: scale(1);\n}\n\n.checkbox-control:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ============================================================\n   Data Table (Cell transitions and headers)\n   ============================================================ */\n\n.data-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.875rem;\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);\n}\n\n.data-table th {\n  text-align: left;\n  padding: 1.125rem 1.25rem;\n  font-weight: 700;\n  font-family: var(--font-heading);\n  background-color: var(--table-thead-background-color);\n  color: var(--table-th-text-color);\n  border-bottom: 1px solid var(--color-border);\n  text-transform: uppercase;\n  letter-spacing: 0.075em;\n  font-size: 0.75rem;\n}\n\n.data-table td {\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--table-split-line-color);\n  color: var(--color-text);\n  vertical-align: middle;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.data-table tbody tr:hover td {\n  background-color: var(--table-tbody-background-color-hover);\n  cursor: pointer;\n}\n\n.data-table__loading,\n.data-table__empty {\n  text-align: center;\n  color: var(--color-text-muted);\n  padding: 2rem;\n}\n\n.table-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n/* Search above a list's table */\n.table-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.search-input {\n  position: relative;\n  flex: 1 1 auto;\n  max-width: 24rem;\n}\n\n.search-input__icon {\n  position: absolute;\n  left: 0.875rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--color-text-muted);\n  pointer-events: none;\n}\n\n.search-input .search-input__field {\n  padding-left: 2.5rem;\n  padding-right: 2.75rem;\n}\n\n/* The X button replaces the browser's own clear control */\n.search-input__field::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n/* Scoped to outrank the Button atom's .btn rules */\n.search-input .search-input__clear {\n  position: absolute;\n  right: 0.25rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--color-text-muted);\n  cursor: pointer;\n  transition:\n    color 0.2s,\n    background-color 0.2s;\n}\n\n.search-input .search-input__clear:hover {\n  color: var(--color-text);\n  background-color: var(--color-primary-soft);\n}\n\n.search-input .search-input__clear:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 1px;\n}\n\n@media (max-width: 640px) {\n  .search-input {\n    max-width: none;\n  }\n}\n\n/* Accesses sub-table inside forms */\n.accesses-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n}\n\n.accesses-table th,\n.accesses-table td {\n  padding: 0.4rem 0.6rem;\n  border: 1px solid var(--color-border);\n  text-align: left;\n}\n\n.accesses-table thead {\n  background-color: var(--table-thead-background-color);\n}\n\n/* ============================================================\n   Pagination\n   ============================================================ */\n\n.pagination {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  flex-wrap: wrap;\n  font-size: 0.875rem;\n}\n\n.pagination select {\n  background-color: var(--color-bg-input);\n  color: var(--color-text);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  padding: 0.3rem 0.5rem;\n  cursor: pointer;\n}\n\n.pagination button {\n  padding: 0.3rem 0.6rem;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background-color: var(--color-bg-input);\n  color: var(--color-text);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.pagination button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.pagination button:not(:disabled):hover {\n  background-color: var(--table-tbody-background-color-hover);\n}\n\n.pagination__page--active {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n  color: #ffffff;\n}\n\n/* ============================================================\n   Modal\n   ============================================================ */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: var(--color-bg-overlay);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1.5rem;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.modal {\n  background-color: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  width: 100%;\n  max-width: 540px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(20px) scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n.modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.modal__header h2 {\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.modal__close {\n  padding: 0.25rem;\n  font-size: 1.5rem;\n  color: var(--color-text-muted);\n  line-height: 1;\n  transition: color 0.15s;\n}\n\n.modal__close:hover {\n  color: var(--color-text);\n}\n\n.modal__body {\n  padding: 1.5rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.modal__footer-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  width: 100%;\n}\n\n.modal__confirm-message {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: var(--color-text);\n  margin: 0;\n}\n\n/* ============================================================\n   Label and ErrorMessage\n   ============================================================ */\n\nlabel,\n.form-label {\n  display: block;\n  font-family: var(--font-heading);\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.075em;\n  margin-bottom: 0.5rem;\n  transition: color 0.2s;\n}\n\nlabel:has(+ .form-control:focus),\nlabel:has(+ .checkbox-control:focus) {\n  color: var(--color-primary);\n}\n\n.checkbox-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-family: var(--font-body);\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--color-text);\n  text-transform: none;\n  letter-spacing: normal;\n  cursor: pointer;\n  margin-bottom: 0;\n  user-select: none;\n}\n\n.checkbox-label .checkbox-control {\n  flex-shrink: 0;\n}\n\n.form-load-state {\n  min-height: 6rem;\n  padding: 1.5rem 0;\n  color: var(--color-text-muted);\n  line-height: 1.5;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.skeleton {\n  display: block;\n  width: 100%;\n  border-radius: 8px;\n  background-color: var(--color-skeleton);\n  animation: skeleton-pulse 1.5s ease-in-out infinite;\n}\n\n/* Each shape matches the rendered size of the component it stands in for */\n.skeleton--input {\n  height: 2.625rem;\n}\n\n.skeleton--textarea {\n  height: 3.8125rem;\n}\n\n.skeleton--upload {\n  height: 3.3125rem;\n}\n\n/* The radio stream player */\n.skeleton--audio {\n  height: 4.625rem;\n  border-radius: 12px;\n}\n\n/* A line of hint text, such as the upload field's accepted types */\n.skeleton--text {\n  width: 60%;\n  height: 0.75rem;\n  margin: 0.625rem 0 0.75rem;\n  border-radius: 4px;\n}\n\n.skeleton--checkbox {\n  display: inline-block;\n  vertical-align: middle;\n  width: 1.25rem;\n  height: 1.25rem;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.skeleton--button {\n  display: inline-block;\n  vertical-align: top;\n  width: 4.5rem;\n  height: 2.4375rem;\n}\n\n@keyframes skeleton-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.45;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .skeleton {\n    animation: none;\n  }\n}\n\n.form-hint {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n  margin-top: 0.375rem;\n  margin-bottom: 0.5rem;\n  font-style: italic;\n  line-height: 1.4;\n}\n\n.error-text {\n  color: var(--color-error);\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-top: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.error-text::before {\n  content: \"⚠\";\n  font-size: 0.875rem;\n}\n\n/* ============================================================\n   Data Table (Cell transitions and headers)\n   ============================================================ */\n\n.data-table__spinner-container,\n.data-table__empty-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  gap: 1rem;\n  color: var(--color-text-muted);\n}\n\n.data-table__spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid rgba(236, 142, 28, 0.2);\n  border-top-color: var(--color-primary);\n  border-radius: 50%;\n  animation: spinner 0.8s linear infinite;\n}\n\n/* A long search term in \"No results for …\" wraps instead of widening the table */\n.data-table__empty-container span {\n  max-width: 100%;\n  overflow-wrap: anywhere;\n}\n\n.data-table__empty-icon {\n  opacity: 0.6;\n}\n\n/* ============================================================\n   Pagination (Refined)\n   ============================================================ */\n\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 0.5rem;\n  margin-top: 1rem;\n  gap: 1.5rem;\n}\n\n.pagination__size-selector select {\n  background-color: var(--color-bg-input);\n  color: var(--color-text);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.pagination__size-selector select:focus {\n  outline: none;\n  border-color: var(--color-border-focus);\n}\n\n.pagination__controls {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pagination__pages {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.pagination__pages .btn {\n  padding: 0.5rem 0.875rem;\n  min-width: 2.5rem;\n}\n\n/* ============================================================\n   Status / feedback text\n   ============================================================ */\n\n.success-text {\n  color: var(--color-success);\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-top: 0.375rem;\n}\n\n/* ============================================================\n   Login page — full-screen centered card\n   ============================================================ */\n\n.main:has(.container:has(.auth-card)) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-card {\n  background-color: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 3rem 2.5rem;\n  width: 100%;\n  max-width: 440px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.4);\n}\n\n.auth-card__title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 2.5rem;\n  color: var(--color-text);\n}\n\n.auth-card__content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.auth-card__footer {\n  margin-top: 1.5rem;\n  text-align: center;\n}\n\n/* ============================================================\n   Layout & Page Structure\n   ============================================================ */\n\n.container {\n  width: 100%;\n}\n\n.container--center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.page-header {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.page-header__content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.page-header__title {\n  margin: 0;\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: var(--color-text);\n}\n\n.page-header__subtitle {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.875rem;\n}\n\n.page-header__actions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n/* Select Atom Styles - UI/UX Pro Max Improvements */\n.select-atom-container {\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.select-atom {\n  appearance: none;\n  background-image: none;\n  padding-right: 2.5rem;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1.5px solid var(--color-border-input);\n  background-color: var(--color-bg-input);\n  color: var(--color-text);\n}\n\n.select-atom:hover:not(:disabled) {\n  border-color: var(--color-text-muted);\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.select-atom:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-soft);\n}\n\n.select-atom--disabled {\n  background-color: var(--color-bg);\n  cursor: not-allowed;\n  color: var(--color-text-muted);\n  opacity: 0.7;\n}\n\n.select-atom__icon {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--color-text-muted);\n  width: 1.25rem;\n  height: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s ease-in-out;\n}\n\n.select-atom:focus + .select-atom__icon {\n  color: var(--color-primary);\n}\n\n.form-control--error.select-atom {\n  border-color: var(--color-error);\n}\n\n.form-control--error.select-atom:focus {\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n/* ============================================================\n   Permission Matrix (Refined Design)\n   ============================================================ */\n\n.permission-matrix {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  /* No overflow:hidden: it clips the caption (the grid's title) at the rounded corner; the corner\n     cells below are rounded instead */\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.permission-matrix th {\n  background-color: var(--table-thead-background-color);\n  color: var(--color-text-muted);\n  font-family: var(--font-heading);\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.075em;\n  padding: 0.875rem 1rem;\n  text-align: center;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.permission-matrix th:first-child {\n  text-align: left;\n}\n\n.permission-matrix thead th:first-child {\n  border-top-left-radius: 9px;\n}\n\n.permission-matrix thead th:last-child {\n  border-top-right-radius: 9px;\n}\n\n.permission-matrix tbody tr:last-child > :first-child {\n  border-bottom-left-radius: 9px;\n}\n\n.permission-matrix tbody tr:last-child > :last-child {\n  border-bottom-right-radius: 9px;\n}\n\n/* The row header looks like the first cell it replaces, not like a column header */\n.permission-matrix tbody th[scope=\"row\"] {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--color-border);\n  background: transparent;\n  text-transform: none;\n  font-size: inherit;\n  vertical-align: middle;\n}\n\n/* The grid's title, where the old <label> above the table was. Not .form-label: its display:block\n   would turn the caption into an ordinary box that renders below the header row */\n.permission-matrix__caption {\n  display: table-caption;\n  caption-side: top;\n  text-align: left;\n  padding: 0 0 0.5rem;\n  font-family: var(--font-heading);\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.075em;\n}\n\n.permission-matrix td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: middle;\n  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  text-align: center;\n}\n\n.permission-matrix td:first-child,\n.permission-matrix tbody th[scope=\"row\"] {\n  text-align: left;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.permission-matrix tbody tr:last-child td,\n.permission-matrix tbody tr:last-child th[scope=\"row\"] {\n  border-bottom: none;\n}\n\n.permission-matrix:hover {\n  box-shadow:\n    0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  border-color: var(--color-primary-soft);\n}\n\n.permission-matrix tbody tr:hover td,\n.permission-matrix tbody tr:hover th[scope=\"row\"] {\n  background-color: var(--table-tbody-background-color-hover);\n}\n\n.permission-matrix--disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: not-allowed;\n  filter: grayscale(0.5);\n}\n\n.permission-matrix td .checkbox-control {\n  margin: 0 auto;\n}\n\n.modal--wide {\n  max-width: 680px;\n}\n\n/* ============================================================\n   Audio Atom\n   ============================================================ */\n\n.audio-atom {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.audio-atom__label {\n  font-family: var(--font-heading);\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.075em;\n}\n\n.audio-atom__wrapper {\n  background-color: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 0.75rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.audio-atom__wrapper:hover {\n  border-color: var(--color-primary);\n  box-shadow: 0 10px 15px -3px var(--color-primary-soft);\n}\n\n.audio-atom--error .audio-atom__wrapper {\n  border-color: var(--color-error);\n}\n\n.audio-atom__native {\n  display: none;\n}\n\n.audio-atom__controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.audio-atom__btn {\n  background-color: var(--color-primary-soft);\n  color: var(--color-primary);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.audio-atom__btn:hover:not(:disabled) {\n  background-color: var(--color-primary);\n  color: var(--color-primary-text);\n  transform: scale(1.05);\n}\n\n.audio-atom__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  filter: grayscale(1);\n}\n\n.audio-atom__icon {\n  width: 20px;\n  height: 20px;\n}\n\n.audio-atom__info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.audio-atom__status {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--color-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.audio-atom--error .audio-atom__status {\n  color: var(--color-error);\n}\n\n.audio-atom__source {\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: var(--font-heading);\n}\n\n.audio-atom__error-msg {\n  font-size: 0.75rem;\n  color: var(--color-error);\n  font-weight: 500;\n}\n\n.audio-atom__btn:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\n@media (prefers-color-scheme: dark) {\n  .audio-atom__wrapper {\n    background-color: var(--color-bg-input);\n  }\n}\n\n.audio-atom__volume {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 100px;\n  margin-left: 0.5rem;\n}\n\n.audio-atom__slider {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  background: var(--color-border);\n  outline: none;\n  cursor: pointer;\n}\n\n.audio-atom__slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--color-primary);\n  cursor: pointer;\n  transition: transform 0.1s ease;\n}\n\n.audio-atom__slider::-webkit-slider-thumb:hover {\n  transform: scale(1.2);\n}\n\n.audio-atom__slider:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.audio-atom {\n  container-type: inline-size;\n}\n\n.audio-atom__controls {\n  flex-wrap: wrap;\n}\n\n.audio-atom__stop-btn {\n  background-color: rgba(220, 38, 38, 0.1);\n  color: #dc2626;\n}\n\n.audio-atom__stop-btn:hover:not(:disabled) {\n  background-color: #dc2626;\n  color: #ffffff;\n}\n\n/* When the atom's own width is tight, drop the volume row below play/stop/info.\n   Natural DOM order is preserved: [play][stop][info flex:1] / [volume full-width] */\n@container (max-width: 460px) {\n  .audio-atom__controls {\n    gap: 0.75rem;\n  }\n\n  .audio-atom__volume {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n\n/* ============================================================\n   Settings — My Profile (/settings/me)\n   ============================================================ */\n\n.settings-me {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  overflow: hidden;\n  max-width: 560px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  margin: 0;\n  padding: 0;\n}\n\n.settings-me__field,\n.settings-me__roles {\n  display: flex;\n  align-items: flex-start;\n  padding: 1.125rem 1.5rem;\n  border-bottom: 1px solid var(--color-border);\n  gap: 1rem;\n}\n\n.settings-me__field:last-child,\n.settings-me__roles:last-child {\n  border-bottom: none;\n}\n\n.settings-me__label {\n  font-family: var(--font-heading);\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.075em;\n  min-width: 80px;\n  padding-top: 0.125rem;\n  margin: 0;\n}\n\n.settings-me__value {\n  font-size: 0.9375rem;\n  color: var(--color-text);\n  font-weight: 500;\n  margin: 0;\n}\n\n.settings-me__role-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.settings-me__role-tag {\n  background-color: var(--color-primary-soft);\n  color: var(--color-primary);\n  font-family: var(--font-heading);\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.25rem 0.625rem;\n  border-radius: 6px;\n  border: 1px solid rgba(236, 142, 28, 0.2);\n}\n\n.settings-me__empty {\n  font-size: 0.875rem;\n  color: var(--color-text-muted);\n  font-style: italic;\n}\n\n/* ============================================================\n   Images — list thumbnails and the upload field\n   ============================================================ */\n\n.thumbnail {\n  display: inline-block;\n  vertical-align: middle;\n  object-fit: cover;\n  border-radius: 6px;\n  border: 1px solid var(--color-border);\n  background-color: var(--color-bg);\n}\n\n.thumbnail--round {\n  border-radius: 50%;\n}\n\n/* Low-res copy first, full image faded in over it once loaded (ProgressiveImage atom).\n   The copy is hidden only after the fade, so nothing blinks and transparent images\n   don't keep a blurry copy behind them. */\n.progressive-image {\n  position: relative;\n  overflow: hidden;\n}\n\n.progressive-image > img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.progressive-image__full {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  transition: opacity 0.2s ease-out;\n}\n\n.progressive-image[data-loaded=\"true\"] .progressive-image__full {\n  opacity: 1;\n}\n\n.progressive-image[data-loaded=\"true\"] .progressive-image__low-res {\n  visibility: hidden;\n  transition: visibility 0s linear 0.2s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progressive-image__full,\n  .progressive-image[data-loaded=\"true\"] .progressive-image__low-res {\n    transition: none;\n  }\n}\n\n.thumbnail--empty {\n  border: 0;\n  background: none;\n  color: var(--color-text-muted);\n}\n\n.image-upload__preview {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.image-upload__image {\n  width: 120px;\n  height: 120px;\n  object-fit: cover;\n  border-radius: 8px;\n  border: 1px solid var(--color-border);\n  background-color: var(--color-bg);\n}\n\n.image-upload__input {\n  display: block;\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px dashed var(--color-border-input);\n  border-radius: 8px;\n  background-color: var(--color-bg-input);\n  color: var(--color-text-muted);\n  font-family: inherit;\n  font-size: 0.875rem;\n  cursor: pointer;\n  box-sizing: border-box;\n  transition:\n    border-color 0.2s,\n    background-color 0.2s;\n}\n\n.image-upload__input:hover:not(:disabled) {\n  border-color: var(--color-primary);\n  background-color: var(--color-primary-soft);\n}\n\n.image-upload__input:focus-visible {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-soft);\n}\n\n.image-upload__input:disabled {\n  opacity: 0.6;\n  cursor: progress;\n}\n\n.image-upload__input::file-selector-button {\n  margin-right: 0.75rem;\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--color-primary);\n  border-radius: 6px;\n  background-color: var(--color-bg-card);\n  color: var(--color-primary);\n  font-family: var(--font-body);\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background-color 0.2s,\n    color 0.2s;\n}\n\n.image-upload__input:hover:not(:disabled)::file-selector-button {\n  background-color: var(--color-primary);\n  color: var(--color-primary-text);\n}\n\n/* Checkbox group (fieldset + legend styled like a field label) */\n.checkbox-group {\n  border: 0;\n  padding: 0;\n  margin: 0 0 1.5rem;\n  min-width: 0;\n}\n\n/* A titled group of inputs inside a form (the \"Mobile app\" fieldset of the application form): the\n   browser's border, padding and serif legend reset to the form's look */\n.form-fieldset {\n  min-width: 0;\n  border: 0;\n  padding: 0;\n  margin-inline: 0;\n}\n\n.form-fieldset legend {\n  padding: 0;\n  font-family: var(--font-heading);\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--color-text);\n  margin-bottom: 0.75rem;\n}\n\n.checkbox-group legend {\n  width: 100%;\n  padding: 0;\n  text-align: center;\n  font-family: var(--font-heading);\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.075em;\n  margin-bottom: 0.5rem;\n}\n\n.checkbox-group__options {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.75rem 1.5rem;\n}\n\n.checkbox-group .checkbox-label {\n  min-height: 44px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .image-upload__input,\n  .image-upload__input::file-selector-button {\n    transition: none;\n  }\n}\n\n/* ============================================================\n   Alignment: the base shell centers text; forms and table cells\n   read left-aligned so labels, hints and errors line up with\n   their inputs and cells line up with their headers\n   ============================================================ */\n\n.form-group,\n.data-table td {\n  text-align: left;\n}\n\n.page-hint {\n  color: var(--color-text-muted);\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n}\n\n/* SecretField: masked input with a Show/Hide button on its right */\n.secret-field {\n  display: flex;\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.secret-field .form-control {\n  flex: 1;\n  min-width: 0;\n}\n\n.secret-field__toggle {\n  flex-shrink: 0;\n  min-width: 5.5rem;\n  min-height: 44px;\n}\n\n/* PageSkeleton: the Suspense fallback while a page's code loads */\n.page-skeleton {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding: 2rem;\n}\n\n.skeleton--heading {\n  width: 14rem;\n  max-width: 60%;\n  height: 2.25rem;\n}\n\n.page-skeleton__button {\n  width: 8rem;\n}\n\n.skeleton--table {\n  height: 15rem;\n  border-radius: 10px;\n  margin-top: 1rem;\n}\n\n.data-table__error-icon {\n  color: var(--color-error);\n}\n\n/* \"Locked\" marker on the collaborator functions list: darker text than the shared tag, 4.5:1 in both themes */\n.collaborator-functions__locked {\n  background-color: var(--color-primary-soft);\n  color: #9a3412;\n  font-family: var(--font-heading);\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.25rem 0.625rem;\n  border-radius: 6px;\n  border: 1px solid rgba(236, 142, 28, 0.2);\n}\n\n@media (prefers-color-scheme: dark) {\n  .collaborator-functions__locked {\n    color: var(--color-primary);\n  }\n}\n\n/* Why a function can't be deleted, next to its disabled Delete: the shared .form-hint colour is\n   4.28:1 on the light page background, so this uses a darker grey (4.5:1+ in both themes) */\n.collaborator-functions__in-use {\n  font-size: 0.75rem;\n  font-style: italic;\n  line-height: 1.4;\n  color: var(--color-text-muted-strong);\n}\n\n/* Collaborators list: the function names failed to load */\n.collaborators__unavailable {\n  font-style: italic;\n  color: var(--color-text-muted-strong);\n}\n\n.collaborators__functions-error {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n/* Feed retention notice icon and title in modal header */\n.feed-modal-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.feed-info-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.125rem;\n  height: 1.125rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: 50%;\n  cursor: help;\n  color: var(--color-text-muted-strong);\n  border: 1px solid currentColor;\n  user-select: none;\n  vertical-align: middle;\n  line-height: 1;\n}\n\n.feed-info-icon:hover,\n.feed-info-icon:focus-visible {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n/* Tabs molecule (application page): a row of buttons over panels that stay mounted */\n.tabs__list {\n  display: flex;\n  gap: 0.25rem;\n  overflow-x: auto;\n  border-bottom: 1px solid var(--color-border);\n  margin-bottom: 1.5rem;\n}\n\n.tabs__tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  flex: none;\n  padding: 0.625rem 1rem;\n  min-height: 2.75rem;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  color: var(--color-text-muted-strong);\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.tabs__tab:hover {\n  color: var(--color-text);\n}\n\n.tabs__tab:focus-visible {\n  outline: 2px solid var(--color-border-focus);\n  outline-offset: -2px;\n}\n\n.tabs__tab--active {\n  color: var(--color-text);\n  border-bottom-color: var(--color-primary);\n}\n\n/* The label keeps the text colour (the error red on the page background is 4.28:1 in the light\n   theme); the red underline and the marker carry the error */\n.tabs__tab--error {\n  border-bottom-color: var(--color-error);\n}\n\n.tabs__marker {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 50%;\n  background: var(--color-error);\n  color: var(--color-primary-text);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
